import React from 'react';
import PropTypes from 'prop-types';
import {
	BottomTwoLevelTableRow,
	BottomTwoLevelItem,
	BottomTwoLevelDetailItem,
	BottomTwoLevelRightItem,
} from './style/bottom_two_blurry_line_style';

export const BottomTwoLevelBlurryRow = ({
	enabledColumns,
	isVisible,
	bottomTwoItems,
	bottomTwoRightItems,
	bottomTwoDetailItems,
	numberOfParents,
}) => {
	const list = [];
	let index = 0;

	if (isVisible) {
		if (bottomTwoItems) {
			//looping through the bottom 2 simple items
			for (const key of Object.keys(bottomTwoItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelItem order={enabledColumns[key]} key={index}>
							{bottomTwoItems[key] !== null && <div className="blurry-text"></div>}
						</BottomTwoLevelItem>
					);
					index++;
				}
			}
		}

		if (bottomTwoRightItems) {
			//looping through the bottom 2 simple right aligned items
			for (const key of Object.keys(bottomTwoRightItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelRightItem order={enabledColumns[key]} key={index}>
							{bottomTwoRightItems[key] !== null && <div className="blurry-text"></div>}
						</BottomTwoLevelRightItem>
					);
					index++;
				}
			}
		}

		if (bottomTwoDetailItems) {
			//looping through the bottom 2 flex 1 items
			for (const key of Object.keys(bottomTwoDetailItems)) {
				if (enabledColumns[key] !== undefined && enabledColumns[key] !== 0) {
					list.push(
						<BottomTwoLevelDetailItem order={enabledColumns[key]} key={index}>
							{bottomTwoDetailItems[key] !== null && <div className="blurry-text"></div>}
						</BottomTwoLevelDetailItem>
					);
					index++;
				}
			}
		}
	}

	return (
		<>
			<BottomTwoLevelTableRow numberOfParents={numberOfParents}>{list}</BottomTwoLevelTableRow>
		</>
	);
};

BottomTwoLevelBlurryRow.propTypes = {
	isVisible: PropTypes.bool,
	numberOfLevels: PropTypes.bool,
	isFirstRow: PropTypes.bool,
	isExpanded: PropTypes.bool,
	mainItem: PropTypes.object,
	reportedTime: PropTypes.string,
	assigneesElement: PropTypes.object,
	projectName: PropTypes.string,
	roleName: PropTypes.string,
	price: PropTypes.string,
	cost: PropTypes.string,
	notes: PropTypes.string,
	taskName: PropTypes.string,
	personIcon: PropTypes.object,
	timeRegType: PropTypes.string,
	projectIcon: PropTypes.object,
	timeRegDetail: PropTypes.string,
	date: PropTypes.string,
	departmentName: PropTypes.string,
	clientName: PropTypes.string,
	billable: PropTypes.string,
	bottomTwoItems: PropTypes.object,
	bottomTwoDetailItems: PropTypes.object,
	bottomTwoGreyItems: PropTypes.object,
	bottomTwoRightItems: PropTypes.object,
	numberOfParents: PropTypes.number,

	enabledColumns: PropTypes.shape({
		needingSpace: PropTypes.bool,
		projectIcon: PropTypes.bool,
		mainItem: PropTypes.bool,
		caretIcon: PropTypes.bool,
		personIcon: PropTypes.bool,
		personName: PropTypes.bool,
		reportedTime: PropTypes.bool,
		timeRegType: PropTypes.bool,
		timeRegDetail: PropTypes.bool,
		projectName: PropTypes.bool,
		roleName: PropTypes.bool,
		price: PropTypes.bool,
		cost: PropTypes.bool,
		date: PropTypes.bool,
		notes: PropTypes.bool,
		taskName: PropTypes.bool,
		showBottom: PropTypes.bool,
		departmentName: PropTypes.bool,
		clientName: PropTypes.bool,
		billable: PropTypes.bool,
	}).isRequired,
};
